app.directive('selectSingleDatepicker', ['$filter', '$timeout', function ($filter, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            'title': '@',
            'default': '@',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'classDropdown': '@',
            'ngmodel': '=',
            'ngmodelmax': '=',
            'ngdatetype': '='

        },
        templateUrl: "application/templates/directives/selectSingleDatepicker.html",
        link: function (scope, element, attrs) {
            var container = document.getElementsByClassName('zone-blocks-slide-right')[0];
            var pCalendarAbsolut = element[0].querySelector('.pCalendarAbsolut');
            var offset = element[0].getBoundingClientRect().top;

            angular.element(container).bind("scroll", function () {
                var res = offset - container.scrollTop - 50;
                pCalendarAbsolut.style.top = res + 'px';
            });
        },
        controller: function ($scope) {
            $scope.top = 0;
            $scope.hideSpan = $scope.default ? true : false;

            $scope.default = $scope.default ? $scope.default : null;

            $scope.showCalendar = true;
            $scope.getPosition = function (event) {
                var element = $(event.target).hasClass("list-item") ? event.target : $(event.target).closest(".list-item");
                var position = $(element).offset();
                var positionHeader = $("#header").height();
                $scope.top = position.top - positionHeader - 1;
            };

            $scope.showDatePicker = function () {
                $scope.showCalendar = true;
            };

            $scope.changeValue = function (value) {
                $scope.default = value;
                $scope.hideSpan = $scope.default ? true : false;
            };


            $scope.$watch('dateSingle', function (newValue, oldValue) {
                if (newValue) {
                    $scope.change();
                }
            });

            $scope.$watch('periodBegin', function (newValue, oldValue) {
                if ($scope.periodBegin && $scope.periodEnd) {
                    $scope.change();
                }
            });

            $scope.$watch('periodEnd', function (newValue, oldValue) {
                if ($scope.periodBegin && $scope.periodEnd) {
                    $scope.change();
                }
            });

            $scope.preventClick = function ($event) {
                $event.preventDefault();
                $event.stopImmediatePropagation();
            };

            $scope.change = function () {
                var getFirstDayWeek = function (date) {
                    d = new Date(date);
                    var day = d.getDay(),
                        diff = d.getDate() - day + (day == 0 ? -6 : 1);
                    return new Date(d.setDate(diff));
                };

                var getLastDayWeek = function (date) {
                    var d = getFirstDayWeek(new Date(date));
                    var diff = d.getDate() + 6;
                    return new Date(d.setDate(diff));
                };

                var leadingZero = function (value) {
                    if (value < 10) {
                        return "0" + value.toString();
                    }
                    return value.toString();
                };

                switch ($scope.type) {
                    case "dateSingle":
                        $scope.dateText = $scope.dateSingle;
                        $scope.ngmodel = $scope.dateText;
                        $scope.ngdatetype = 'simple';
                        break;
                    case "dateSingle-allDaysBefore":
                        $scope.dateText = $scope.dateSingle;
                        $scope.ngmodel = $scope.dateText;
                        $scope.ngdatetype = 'Before';
                        break;
                    case "dateSingle-allDaysAfter":
                        $scope.dateText = $scope.dateSingle;
                        $scope.ngmodel = $scope.dateText;
                        $scope.ngdatetype = 'After';
                        break;

                    case "period":
                        $scope.dateText = $scope.periodBegin + " - " + $scope.periodEnd;
                        $scope.ngmodel = $scope.periodBegin;
                        $scope.ngmodelmax = $scope.periodEnd;
                        $scope.ngdatetype = 'Period';
                        break;

                    case "today":
                        var d = new Date();
                        $scope.dateText = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                        $scope.ngmodel = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                        break;

                    case "week":
                        var firstDate = getFirstDayWeek(new Date());
                        var lastDate = getLastDayWeek(new Date());

                        $scope.dateText = (leadingZero(firstDate.getDate()) + "/" + leadingZero(firstDate.getMonth() + 1) + "/" + firstDate.getFullYear())
                            + " - " + (leadingZero(lastDate.getDate()) + "/" + leadingZero(lastDate.getMonth() + 1) + "/" + lastDate.getFullYear());
                        $scope.ngmodel = (leadingZero(firstDate.getDate()) + "/" + leadingZero(firstDate.getMonth() + 1) + "/" + firstDate.getFullYear());
                        $scope.ngmodelmax = (leadingZero(lastDate.getDate()) + "/" + leadingZero(lastDate.getMonth() + 1) + "/" + lastDate.getFullYear());
                        $scope.ngdatetype = 'Period';
                        break;

                    case "month":
                        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                        var firstDate = new Date(y, m, 1);
                        var lastDate = new Date(y, m + 1, 0);

                        $scope.dateText = (leadingZero(firstDate.getDate()) + "/" + leadingZero(firstDate.getMonth() + 1) + "/" + firstDate.getFullYear())
                            + " - " + (leadingZero(lastDate.getDate()) + "/" + leadingZero(lastDate.getMonth() + 1) + "/" + lastDate.getFullYear());
                        $scope.ngmodel = (leadingZero(firstDate.getDate()) + "/" + leadingZero(firstDate.getMonth() + 1) + "/" + firstDate.getFullYear());
                        $scope.ngmodelmax = (leadingZero(lastDate.getDate()) + "/" + leadingZero(lastDate.getMonth() + 1) + "/" + lastDate.getFullYear());
                        $scope.ngdatetype = 'Period';
                        break;

                    case "hollydays-summer":
                        var date = new Date(), y = date.getFullYear(), m = 7;
                        var firstDate = new Date(y, m, 1);
                        var lastDate = new Date(y, m + 1, 0);

                        $scope.dateText = (leadingZero(firstDate.getDate()) + "/" + leadingZero(firstDate.getMonth() + 1) + "/" + firstDate.getFullYear())
                            + " - " + (leadingZero(lastDate.getDate()) + "/" + leadingZero(lastDate.getMonth() + 1) + "/" + lastDate.getFullYear());
                        $scope.ngmodel = $scope.dateText;
                        break;

                }

            }
        }
    }
}]);
